/* eslint-disable max-len */
/* eslint-disable object-shorthand */
/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
import { Scene } from 'phaser';
import EDC from '@/components/games/shared/globals';
import CursorManager from '@/components/games/shared/cursor-manager';
import router from '@/router';
import store from '@/store';

class GameKickoffMainScene extends Scene {
  init() {
    this.bg = null;
    this.content = null;
    this.cursorManager = null;
    this.logo = null;
    this.scale.off('resize', this.resize, this);
  }

  create() {
    const gameId = router.currentRoute.params.id;
    const gameConfig = store.getters['games/getGameById'](gameId);

    this.cursorManager = new CursorManager(this.game.canvas);
    this.cursorManager.resetCursor();

    // bg
    this.bg = this.add.sprite(this.scale.width / 2, this.scale.height / 2, 'background');
    this.content = this.add.container().setInteractive();

    // title
    const title_frame = this.add.sprite(0, 220, 'title_frame').setOrigin(0);
    const title = this.add.sprite(
      title_frame.x + title_frame.displayWidth / 2,
      title_frame.y + title_frame.displayHeight / 2,
      'title',
    );

    // logo
    this.logo = this.add.sprite(0, 0, 'logo');
    this.logo.init_scale = 1;

    // thumbnail
    const thumbnail_frame = this.add
      .sprite(title_frame.x + title_frame.displayWidth / 2, title_frame.y + 525, 'thumbnail_frame')
      .setInteractive();
    thumbnail_frame.init_scaleX = thumbnail_frame.scaleX;
    thumbnail_frame.init_scaleY = thumbnail_frame.scaleY;
    thumbnail_frame.setScale(0.1);
    thumbnail_frame.on('pointerdown', this.nextPage.bind(this));
    this.cursorManager.setDefaultDraggableEvents(thumbnail_frame);
    const thumbnail_image = this.add.sprite(
      title_frame.x + title_frame.displayWidth / 2,
      title_frame.y + 525,
      'thumbnail_image',
    );
    thumbnail_image.init_scaleX = thumbnail_image.scaleX;
    thumbnail_image.init_scaleY = thumbnail_image.scaleY;
    thumbnail_image.setScale(0.1);

    // continue button
    const continue_container = this.add.container(thumbnail_frame.x, thumbnail_frame.y + 270);
    const continue_btn = this.add.sprite(25, 0, 'btn_continue_frame');
    const continue_txt = this.add.sprite(-35, 0, 'btn_continue_text');
    const continue_arrow = this.add.sprite(300, 0, 'btn_continue_arrow');
    continue_container.add([continue_btn, continue_txt, continue_arrow]);
    continue_container.setSize(continue_btn.displayWidth, continue_btn.displayHeight);
    this.tweens.add({
      targets: continue_arrow,
      ease: 'Sine.easeInOut',
      duration: 1000,
      x: continue_arrow.x + 20,
      loop: -1,
      yoyo: true,
    });
    continue_container.setInteractive();
    continue_container.on('pointerover', () => {
      continue_btn.setTexture('btn_continue_frame_hover');
    });
    continue_container.on('pointerout', () => {
      continue_btn.setTexture('btn_continue_frame');
    });
    continue_container.on('pointerdown', this.nextPage.bind(this));
    this.cursorManager.setDefaultDraggableEvents(continue_container);

    // back button
    const back_container = this.add.container(thumbnail_frame.x, thumbnail_frame.y + 445);
    const back_btn = this.add.sprite(-400, 0, 'btn_back_frame');
    const back_txt = this.add.sprite(30, 0, 'btn_back_text');
    const back_arrow = this.add.sprite(-410, 0, 'btn_back_arrow');
    back_container.add([back_btn, back_txt, back_arrow]);
    back_container.setSize(
      back_btn.displayWidth + back_txt.displayWidth,
      back_btn.displayHeight + back_txt.displayHeight,
    );
    back_container.setInteractive();
    back_container.on('pointerover', () => {
      back_btn.setTexture('btn_back_frame_hover');
    });
    back_container.on('pointerout', () => {
      back_btn.setTexture('btn_back_frame');
    });
    back_container.on('pointerdown', this.goBack.bind(this));
    this.cursorManager.setDefaultDraggableEvents(back_container);

    // grade
    const grade_frame = this.add.sprite(thumbnail_frame.x - 620, thumbnail_frame.y - 110, 'stats_frame').setAlpha(0.5);
    const grade_label = this.add.sprite(thumbnail_frame.x - 660, thumbnail_frame.y - 110, 'grade_label');
    const grade_box = this.add.sprite(thumbnail_frame.x - 440, thumbnail_frame.y - 110, 'small_frame');
    let grade = gameConfig?.grade;
    if (grade < 1) grade = 'k';
    const grade_number = this.add.sprite(thumbnail_frame.x - 440, thumbnail_frame.y - 110, `grade_${grade}`);

    // level
    const level_frame = this.add.sprite(thumbnail_frame.x - 620, thumbnail_frame.y + 85, 'stats_frame').setAlpha(0.5);
    level_frame.displayHeight *= 1.3;
    const level_label = this.add.sprite(thumbnail_frame.x - 620, thumbnail_frame.y + 30, 'level_label');
    let level_stars_count = this.getStarsCount();
    const level_stars = this.add.container(thumbnail_frame.x - 805, thumbnail_frame.y + 120);
    let level_star;
    for (let i = 0; i < 5; i++) {
      if (level_stars_count > 0) {
        level_star = this.add.sprite(i * 95, 0, 'star_full');
      } else {
        level_star = this.add.sprite(i * 95, 0, 'star_empty');
      }
      level_stars.add(level_star);
      level_stars_count -= 1;
    }

    // category
    const category_frame = this.add.sprite(thumbnail_frame.x + 620, thumbnail_frame.y - 110, 'stats_frame').setAlpha(0.5);
    const category_label = this.add.sprite(thumbnail_frame.x + 550, thumbnail_frame.y - 110, 'category_label');
    const category_box = this.add.sprite(thumbnail_frame.x + 865, thumbnail_frame.y - 110, 'small_frame');
    const category_icon = this.add
      .sprite(thumbnail_frame.x + 865, thumbnail_frame.y - 110, `icons_${gameConfig?.category}`)
      .setScale(0.34);

    // rating
    const rating_frame = this.add.sprite(thumbnail_frame.x + 620, thumbnail_frame.y + 85, 'stats_frame').setAlpha(0.5);
    rating_frame.displayHeight *= 1.3;
    const rating_label = this.add.sprite(thumbnail_frame.x + 600, thumbnail_frame.y + 45, 'rating_label');
    const rating = this.getRating();
    const rating_bar = this.add.sprite(thumbnail_frame.x + 610, thumbnail_frame.y + 135, `ratingbar_${rating}`);
    const rating_text = this.add
      .text(rating_bar.x, rating_bar.y, `${rating * 10}%`, {
        font: '45px Arial',
        color: '#000',
      })
      .setOrigin(0.5);
    // Bounce title
    this.tweens.add({
      targets: title,
      ease: 'Bounce.easeOut',
      duration: 1000,
      y: 400,
      loop: -1,
      yoyo: true,
    });
    // add content
    this.content.add([
      title_frame,
      title,
      thumbnail_frame,
      thumbnail_image,
      continue_container,
      back_container,
      grade_frame,
      grade_label,
      grade_box,
      grade_number,
      category_frame,
      category_label,
      category_box,
      category_icon,
      level_frame,
      level_label,
      level_stars,
      rating_frame,
      rating_label,
      rating_bar,
      rating_text,
    ]);

    // resizing
    this.scale.on('resize', this.resize, this);
    this.resize({ width: this.scale.width, height: this.scale.height });

    // tweens
    // title bar
    this.logo.y -= 300;
    title_frame.y -= 300;
    title.y -= 300;
    this.tweens.add({
      targets: [this.logo, title_frame, title],
      duration: 1000,
      y: function (target, targetKey, value, targetIndex, totalTargets, tween) {
        return target.y + 300;
      },
      ease: 'Bounce.easeOut',
    });
    // thumbnail
    this.tweens.add({
      targets: [thumbnail_image, thumbnail_frame],
      duration: 1000,
      scaleX: 1,
      scaleY: 1,
      ease: 'Sine.easeInOut',
      onComplete: () => {
        this.tweens.add({
          targets: [thumbnail_image, thumbnail_frame],
          duration: 1000,
          scaleX: 0.97,
          scaleY: 0.97,
          repeat: -1,
          yoyo: true,
          ease: 'Sine.easeInOut',
        });
      },
    });
    // grade & level
    const leftTargets = [
      grade_frame,
      grade_label,
      grade_box,
      grade_number,
      level_frame,
      level_label,
      level_stars];
    leftTargets.map((target) => {
      target.x -= 1000;
    });
    this.tweens.add({
      targets: leftTargets,
      duration: 750,
      x: function (target, targetKey, value, targetIndex, totalTargets, tween) {
        return target.x + 1000;
      },
    });
    // category & rating
    const rightTargets = [
      category_frame,
      category_label,
      category_box,
      category_icon,
      rating_frame,
      rating_label,
      rating_bar,
      rating_text,
    ];
    rightTargets.map((target) => {
      target.x += 1000;
    });
    this.tweens.add({
      targets: rightTargets,
      duration: 750,
      x: function (target, targetKey, value, targetIndex, totalTargets, tween) {
        return target.x - 1000;
      },
    });
    // buttons
    back_container.y += 500;
    continue_container.y += 500;
    this.tweens.add({
      targets: [back_container, continue_container],
      duration: 750,
      y: function (target, targetKey, value, targetIndex, totalTargets, tween) {
        return target.y - 500;
      },
    });
  }

  goBack() {
    router.push({ name: 'game-type-picker' });
    this.game.destroy(true);
  }

  nextPage() {
    this.game.destroy(true);
    this.game.canvas.remove();
    window.activeGame = window.miniGame();
  }

  getStarsCount() {
    const star_count = 3;
    return star_count;
  }

  getRating() {
    const rating = 8;
    return rating;
  }

  resize(gameSize, baseSize, displaySize, resolution) {
    const { width } = gameSize;
    const { height } = gameSize;
    this.cameras.resize(width, height);
    const bgW = this.bg.width;
    const neededScaleX = width / bgW;
    const bgH = this.bg.height;
    const neededScaleY = height / bgH;
    let neededScale = neededScaleX > neededScaleY ? neededScaleX : neededScaleY;
    this.bg.setScale(neededScale);
    this.bg.setPosition(width / 2, height / 2);
    this.content.setPosition(0, 0);
    this.content.setScale(1, 1);
    let bounds = this.content.getBounds();
    const contentWidth = bounds.width;
    const contentHeight = bounds.height;
    const scaleX = (width * 0.95) / contentWidth;
    const scaleY = (height * 0.95) / contentHeight;
    neededScale = scaleX > scaleY ? scaleY : scaleX;
    this.content.setScale(neededScale);
    bounds = this.content.getBounds();
    this.content.setPosition(
      (width - bounds.width) / 2 + 310 * neededScale,
      height / 2 - bounds.height + 300 * neededScale,
    );
    this.logo.setScale(this.logo.init_scale * neededScale);
    this.logo.setPosition(this.content.x + bounds.width / 2 - 990 * neededScale, this.content.y + 372 * neededScale);
  }
}

EDC.Games.GameKickoff.Scenes.Main = GameKickoffMainScene;

export default GameKickoffMainScene;
